import React, { forwardRef } from 'react';
import { CONFIG } from '../data/config';
import { CartItemType, CheckoutData } from '../types/types';
interface OrderTicketProps {
  orderNumber: string;
  data: CheckoutData;
  items: CartItemType[];
  cartTotal: number;
  totalFinal: number;
}
export const OrderTicket = forwardRef<HTMLDivElement, OrderTicketProps>(({
  orderNumber,
  data,
  items,
  cartTotal,
  totalFinal
}, ref) => {
  const expressFee = data.entrega === 'Express' ? CONFIG.EXPRESS_FEE : 0;
  const vuelto = data.metodoPago === 'Efectivo' && data.montoEfectivo ? parseInt(data.montoEfectivo) - totalFinal : 0;
  return <div ref={ref} style={{
    width: 380,
    fontFamily: "'Inter', sans-serif",
    background: '#FFFFFF',
    position: 'relative',
    overflow: 'hidden'
  }} data-id="element-234">
        {/* Watermark logo background */}
        <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 260,
      height: 260,
      opacity: 0.04,
      pointerEvents: 'none'
    }} data-id="element-235">
          <img src={CONFIG.LOGO_URL} alt="" style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain'
      }} crossOrigin="anonymous" data-id="element-236" />
        </div>

        {/* Content */}
        <div style={{
      position: 'relative',
      zIndex: 1,
      padding: '28px 24px'
    }} data-id="element-237">
          {/* Header with logo */}
          <div style={{
        textAlign: 'center',
        marginBottom: 20
      }} data-id="element-238">
            <img src={CONFIG.LOGO_URL} alt={CONFIG.APP_NAME} style={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          objectFit: 'cover',
          margin: '0 auto 10px',
          display: 'block',
          border: '2px solid #A8C46A'
        }} crossOrigin="anonymous" data-id="element-239" />
            <div style={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: 22,
          fontWeight: 700,
          color: '#B6461F',
          marginBottom: 2
        }} data-id="element-240">
              {CONFIG.APP_NAME}
            </div>
            <div style={{
          fontSize: 11,
          color: '#8CB33F',
          fontWeight: 500,
          letterSpacing: 0.5
        }} data-id="element-241">
              {CONFIG.APP_TAGLINE}
            </div>
          </div>

          {/* Dashed divider */}
          <div style={{
        borderTop: '2px dashed #e5e5e0',
        margin: '16px 0'
      }} data-id="element-242" />

          {/* Order number */}
          <div style={{
        textAlign: 'center',
        marginBottom: 16
      }} data-id="element-243">
            <div style={{
          display: 'inline-block',
          background: '#f0f7e4',
          borderRadius: 8,
          padding: '6px 16px',
          fontSize: 13,
          fontWeight: 600,
          color: '#6FA82C',
          letterSpacing: 0.5
        }} data-id="element-244">
              PEDIDO #{orderNumber}
            </div>
          </div>

          {/* Client info */}
          <div style={{
        marginBottom: 14
      }} data-id="element-245">
            <div style={sectionTitleStyle} data-id="element-246">DATOS DEL CLIENTE</div>
            <div style={rowStyle} data-id="element-247">
              <span style={labelStyle} data-id="element-248">Nombre</span>
              <span style={valueStyle} data-id="element-249">{data.nombre}</span>
            </div>
            <div style={rowStyle} data-id="element-250">
              <span style={labelStyle} data-id="element-251">Teléfono</span>
              <span style={valueStyle} data-id="element-252">{data.telefono}</span>
            </div>
          </div>

          {/* Delivery */}
          <div style={{
        marginBottom: 14
      }} data-id="element-253">
            <div style={sectionTitleStyle} data-id="element-254">TIPO DE ENTREGA</div>
            <div style={rowStyle} data-id="element-255">
              <span style={labelStyle} data-id="element-256">Entrega</span>
              <span style={valueStyle} data-id="element-257">{data.entrega}</span>
            </div>
            {data.entrega === 'Express' && <>
                {data.direccion && <div style={rowStyle} data-id="element-258">
                    <span style={labelStyle} data-id="element-259">Dirección</span>
                    <span style={{
              ...valueStyle,
              maxWidth: 180,
              textAlign: 'right'
            }} data-id="element-260">
                      {data.direccion}
                    </span>
                  </div>}
                <div style={rowStyle} data-id="element-261">
                  <span style={labelStyle} data-id="element-262">Cargo express</span>
                  <span style={valueStyle} data-id="element-263">
                    {CONFIG.CURRENCY_SYMBOL}
                    {CONFIG.EXPRESS_FEE.toLocaleString()}
                  </span>
                </div>
              </>}
          </div>

          {/* Payment */}
          <div style={{
        marginBottom: 14
      }} data-id="element-264">
            <div style={sectionTitleStyle} data-id="element-265">MÉTODO DE PAGO</div>
            <div style={rowStyle} data-id="element-266">
              <span style={labelStyle} data-id="element-267">Pago</span>
              <span style={valueStyle} data-id="element-268">{data.metodoPago}</span>
            </div>
            {data.metodoPago === 'Efectivo' && data.montoEfectivo && <>
                <div style={rowStyle} data-id="element-269">
                  <span style={labelStyle} data-id="element-270">Paga con</span>
                  <span style={valueStyle} data-id="element-271">
                    {CONFIG.CURRENCY_SYMBOL}
                    {parseInt(data.montoEfectivo).toLocaleString()}
                  </span>
                </div>
                {vuelto > 0 && <div style={rowStyle} data-id="element-272">
                    <span style={labelStyle} data-id="element-273">Vuelto</span>
                    <span style={valueStyle} data-id="element-274">
                      {CONFIG.CURRENCY_SYMBOL}
                      {vuelto.toLocaleString()}
                    </span>
                  </div>}
              </>}
          </div>

          {/* Dashed divider */}
          <div style={{
        borderTop: '2px dashed #e5e5e0',
        margin: '16px 0'
      }} data-id="element-275" />

          {/* Order items */}
          <div style={{
        marginBottom: 14
      }} data-id="element-276">
            <div style={sectionTitleStyle} data-id="element-277">PEDIDO</div>
            {items.map((item, index) => <div key={item.id} style={{
          marginBottom: 12
        }} data-id="element-278">
                <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: 3
          }} data-id="element-279">
                  <span style={{
              fontSize: 13,
              fontWeight: 600,
              color: '#1f2937',
              flex: 1
            }} data-id="element-280">
                    {index + 1}. {item.name} (x{item.quantity})
                  </span>
                  <span style={{
              fontSize: 13,
              fontWeight: 700,
              color: '#B6461F',
              whiteSpace: 'nowrap',
              marginLeft: 8
            }} data-id="element-281">
                    {CONFIG.CURRENCY_SYMBOL}
                    {(item.subtotal * item.quantity).toLocaleString()}
                  </span>
                </div>
                {renderSelections(item)}
              </div>)}
          </div>

          {/* Comments */}
          {(data.comentarios || data.alergias) && <div style={{
        marginBottom: 14
      }} data-id="element-282">
              <div style={sectionTitleStyle} data-id="element-283">COMENTARIOS</div>
              {data.alergias && <div style={{
          fontSize: 12,
          color: '#dc2626',
          marginBottom: 3
        }} data-id="element-284">
                  ⚠️ {data.alergias}
                </div>}
              {data.comentarios && <div style={{
          fontSize: 12,
          color: '#6b7280'
        }} data-id="element-285">
                  {data.comentarios}
                </div>}
            </div>}

          {/* Dashed divider */}
          <div style={{
        borderTop: '2px dashed #e5e5e0',
        margin: '16px 0'
      }} data-id="element-286" />

          {/* Totals */}
          <div style={{
        marginBottom: 8
      }} data-id="element-287">
            <div style={rowStyle} data-id="element-288">
              <span style={labelStyle} data-id="element-289">Subtotal</span>
              <span style={valueStyle} data-id="element-290">
                {CONFIG.CURRENCY_SYMBOL}
                {cartTotal.toLocaleString()}
              </span>
            </div>
            {expressFee > 0 && <div style={rowStyle} data-id="element-291">
                <span style={labelStyle} data-id="element-292">Express</span>
                <span style={valueStyle} data-id="element-293">
                  {CONFIG.CURRENCY_SYMBOL}
                  {expressFee.toLocaleString()}
                </span>
              </div>}
            <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px 0 4px',
          borderTop: '1px solid #e5e5e0',
          marginTop: 8
        }} data-id="element-294">
              <span style={{
            fontSize: 15,
            fontWeight: 700,
            color: '#1f2937',
            fontFamily: "'Poppins', sans-serif"
          }} data-id="element-295">
                TOTAL
              </span>
              <span style={{
            fontSize: 20,
            fontWeight: 800,
            color: '#B6461F',
            fontFamily: "'Poppins', sans-serif"
          }} data-id="element-296">
                {CONFIG.CURRENCY_SYMBOL}
                {totalFinal.toLocaleString()}
              </span>
            </div>
          </div>

          {/* Footer */}
          <div style={{
        textAlign: 'center',
        marginTop: 20,
        paddingTop: 14,
        borderTop: '2px dashed #e5e5e0'
      }} data-id="element-297">
            <div style={{
          fontSize: 12,
          color: '#8CB33F',
          fontWeight: 600
        }} data-id="element-298">
              ¡Gracias por tu pedido! 🌿
            </div>
            <div style={{
          fontSize: 10,
          color: '#9ca3af',
          marginTop: 4
        }} data-id="element-299">
              {CONFIG.APP_NAME} • Comida saludable
            </div>
          </div>
        </div>
      </div>;
});
function renderSelections(item: CartItemType) {
  const s = item.selections;
  const lines: string[] = [];
  if (s.base) lines.push(`Base: ${s.base.name}`);
  if (s.proteina) lines.push(`Proteína: ${s.proteina.name}`);
  if (s.toppings?.length) lines.push(`Toppings: ${s.toppings.map(t => t.name).join(', ')}`);
  if (s.toppingsPremium?.length) lines.push(`Premium: ${s.toppingsPremium.map(t => t.name).join(', ')}`);
  if (s.aderezos?.length) lines.push(`Aderezos: ${s.aderezos.map(t => t.name).join(', ')}`);
  if (s.semillas?.length) lines.push(`Semillas: ${s.semillas.map(t => t.name).join(', ')}`);
  if (s.comentarios) lines.push(`Notas: ${s.comentarios}`);
  if (lines.length === 0) return null;
  return <div style={{
    paddingLeft: 16
  }} data-id="element-300">
      {lines.map((line, i) => <div key={i} style={{
      fontSize: 11,
      color: '#6b7280',
      lineHeight: 1.5
    }} data-id="element-301">
          • {line}
        </div>)}
    </div>;
}
const sectionTitleStyle: React.CSSProperties = {
  fontSize: 10,
  fontWeight: 700,
  color: '#8CB33F',
  letterSpacing: 1.5,
  textTransform: 'uppercase',
  marginBottom: 8,
  fontFamily: "'Poppins', sans-serif"
};
const rowStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 4
};
const labelStyle: React.CSSProperties = {
  fontSize: 12,
  color: '#6b7280'
};
const valueStyle: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: '#1f2937'
};